"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SelectedFieldsToAssign;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _chip = _interopRequireDefault(require("./styled/chip"));

function SelectedFieldsToAssign(_ref) {
  var values = _ref.values,
      _onDelete = _ref.onDelete;
  return values.map(function (value, index) {
    var key = "field-".concat(index);
    return /*#__PURE__*/_react["default"].createElement(_chip["default"], {
      key: key,
      label: value,
      title: value,
      variant: "neutral",
      onDelete: function onDelete() {
        return _onDelete(value);
      }
    });
  });
}

SelectedFieldsToAssign.propTypes = {
  values: _propTypes["default"].array,
  onDelete: _propTypes["default"].func
};
SelectedFieldsToAssign.defaultProps = {
  values: [],
  onDelete: function onDelete() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ImportRecordsFlow/stepThree/selectedFieldsToAssign.js
// module id = VuUZ
// module chunks = 0